import { Button } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useMachineLicensesAssignment } from "../../../hooks/infrastructure/machinelicenses/useMachineLicensesAssignment";

type MachineLicensesAssignmentButtonProps = {
  assignmentData: any;
  // setDrawerOpen: (isDrawerOpen: boolean) => void;
  callbackFn: () => void
};

export const MachineLicensesAssignmentButton: React.FC<MachineLicensesAssignmentButtonProps> = ({
  assignmentData,

  callbackFn
}) => {
  const { t } = useTranslation();
  //  console.log("Payload ", assignmentData)
  const [machineLicensesAssignment, isLoading] = useMachineLicensesAssignment(assignmentData);


  return (
    <Button
      type="primary"
      size="large"
      onClick={async () => {
        const license: any = await machineLicensesAssignment();

        if (license) {
          //  setDrawerOpen(false)
          callbackFn()
        }
      }}
      loading={isLoading}
    >
      {t('machineLicenses.licenseAssignment.actions.save.button')}
    </Button>
  );
};
